import { render, staticRenderFns } from "./v-hero.vue?vue&type=template&id=3c5a2643&scoped=true&"
import script from "./v-hero.vue?vue&type=script&lang=js&"
export * from "./v-hero.vue?vue&type=script&lang=js&"
import style0 from "./v-hero.vue?vue&type=style&index=0&id=3c5a2643&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a2643",
  null
  
)

export default component.exports